module.exports = __webpack_public_path__ + "static/media/abdu.c480d5b6.jpeg";